import { api } from "@api/api";

export async function deleteConfigService(id: number): Promise<void> {
  await api.delete(`/v1/agreement_integration_config_admin/${id}/`);
}
